import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
// import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import schoolList from './schoolList';
import majorList from './majorList';

const { Group, Label, Control } = Form;

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'left',
  },
  title: {
    fontSize: 48,
    color: theme.palette.primary.main,
    fontFamily: 'DM Sans , sans-serif',
    fontSize: '40px',
    fontWeight: 'bold',
    alignSelf: 'flex-start',
  },
  description: {
    color: '#777777',
  },
  chipText: {
    fontSize: '18px',
    paddingLeft: '12px',
    paddingRight: '12px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  label: {
    color: theme.palette.secondary.main,
  },
  buttonOption: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    color: '#000000',
    borderRadius: '4px',
    border: '1px solid',
    borderColor: '#7B7B7B',
    '&:hover': {
      borderColor: theme.palette.secondary.light,
      backgroundColor: '#FCFCFD',
      color: theme.palette.secondary.light,
    },
    '&:visited': {
      borderColor: theme.palette.secondary.light,
      backgroundColor: '#7B7B7B',
      color: theme.palette.secondary.light,
    },
  },
  buttonSelect: {
    width: '100%',
    borderRadius: '4px',
    border: '1px solid',
    borderColor: '#7B7B7B',
  },
}));

const AboutYou = (props) => {
  const classes = useStyles();
  const { formInfo, setFormInfo } = props;
  const [showShirtSize, setShowShirtSize] = useState(false);

  const handleForm = (key, value) => {
    if (key === 'major') {
      setFormInfo((prevFormInfo) => ({
        ...prevFormInfo,
        [key]: value ? value : [],
      }));
    } else if (key === 'attendedHWBefore' || key === 'swag') {
      const newFormInfo = { ...formInfo, [key]: value };
      setFormInfo(newFormInfo);
    } else {
      const newFormInfo = { ...formInfo, [key]: value ? value : '' };
      setFormInfo(newFormInfo);
    }
  };

  const yearOfStudies = [
    'Undergrad - First',
    'Undergrad - Second',
    'Undergrad - Third',
    'Undergrad - Fourth',
    'Undergrad - Other',
    'Graduate/PhD',
  ];

  const provinces = [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'Quebec',
    'Ontario',
    'Northwest Territories',
    'Nunavut',
    'Saskatchewan',
    'Newfoundland and Labrador',
    'Nova Scotia',
    'Prince Edward Island',
    'New Brunswick',
  ];

  const shirtSizes = ['Small', 'Medium', 'Large', 'X-Large', 'XX-Large'];

  return (
    <div className={classes.root}>
      <p className={classes.title}>About You</p>
      <Form className={classes.formWrapper}>
        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              Preferred Pronoun *
            </Typography>
          </Label>
          <Control
            type="text"
            placeholder="ie. they/them/theirs"
            value={formInfo.pronouns}
            onChange={(e) => {
              handleForm('pronouns', e.target.value);
            }}
          />
        </Group>
        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              Date of Birth *
            </Typography>
          </Label>
          <Control
            type="date"
            placeholder="Enter date of birth"
            onChange={(e) => {
              handleForm('birthday', e.target.value);
            }}
          />
          <Control.Feedback type="invalid">Invalid date</Control.Feedback>
          <Control.Feedback>Looks good!</Control.Feedback>
        </Group>
        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              School *
            </Typography>
            <p className={classes.description}>
              Please enter your school name if not listed and press the enter
              key
            </p>
          </Label>

          <Autocomplete
            options={schoolList}
            getOptionLabel={(option) => option}
            autoComplete
            freeSolo
            blurOnSelect={true}
            style={{ backgroundColor: 'white' }}
            value={formInfo.school}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" />
            )}
            onChange={(e, val) => {
              handleForm('school', val);
            }}
            noOptionsText="School not listed? Continue typing in your school."
            // this is to render your own component inside the li
            // renderOption={(option) => (
            //   <Typography
            //     noWrap
            //     style={{
            //       backgroundColor: 'white',
            //       width: '100%',
            //       height: '100%',
            //     }}>
            //     {option}
            //   </Typography>
            // )}
          />
        </Group>
        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              Year of Study *
            </Typography>
          </Label>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <Select
              value={formInfo.schoolYear}
              onChange={(e) => {
                handleForm('schoolYear', e.target.value);
              }}>
              {yearOfStudies.map((year) => (
                <MenuItem value={year} key={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Group>
        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              Your Major *
            </Typography>
            <p className={classes.description}>
              Please enter your major if not listed and press the enter key
            </p>
          </Label>
          <Autocomplete
            options={majorList}
            getOptionLabel={(option) => option}
            autoComplete
            blurOnSelect={true}
            freeSolo
            multiple
            value={formInfo.major}
            renderTags={(value, getTagProps) =>
              value.map((name, index) =>
                name === '' ? null : (
                  <Chip
                    variant="outlined"
                    color="primary"
                    size="medium"
                    label={<div className={classes.chipText}>{name}</div>}
                    {...getTagProps({ index })}
                    onDelete={null}
                  />
                )
              )
            }
            style={{ backgroundColor: 'white' }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" />
            )}
            onChange={(e, val) => {
              console.log(val);
              handleForm('major', val);
            }}
            noOptionsText="Major not listed? Continue typing in your major."
          />
        </Group>

        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              Resume *
            </Typography>
            <p className={classes.description}>
              Just add a public google drive link holding your resume as a PDF
            </p>
          </Label>
          <Control
            type="text"
            value={formInfo.resume}
            onChange={(e) => {
              handleForm('resume', e.target.value);
            }}
          />
        </Group>
        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              LinkedIn
            </Typography>
          </Label>
          <Control
            type="text"
            value={formInfo.linkedin}
            onChange={(e) => {
              handleForm('linkedin', e.target.value);
            }}
          />
        </Group>
        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              GitHub
            </Typography>
          </Label>
          <Control
            type="text"
            value={formInfo.github}
            onChange={(e) => {
              handleForm('github', e.target.value);
            }}
          />
        </Group>
        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              Other Links
            </Typography>
          </Label>
          <Control
            type="text"
            value={formInfo.otherLink}
            placeholder="Your personal website or a past project"
            onChange={(e) => {
              handleForm('otherLink', e.target.value);
            }}
          />
        </Group>

        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              Where will you be Hacking from?
            </Typography>
            <p className={classes.description}>
              We'll ship swag and prizes to this address. (Only Canadian
              addresses will receive swag)
            </p>
          </Label>
          <Form.Group>
            <Form.Label>
              <Typography variant="h5" className={classes.label}>
                Address *
              </Typography>
            </Form.Label>
            <Form.Control
              value={formInfo.address}
              onChange={(e) => {
                handleForm('address', e.target.value);
              }}
              placeholder="1234 Main St"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>
              <Typography variant="h5" className={classes.label}>
                Address 2
              </Typography>
            </Form.Label>
            <Form.Control
              value={formInfo.addressTwo}
              onChange={(e) => {
                handleForm('addressTwo', e.target.value);
              }}
              placeholder="Apartment, studio, or floor"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>
              <Typography variant="h5" className={classes.label}>
                Province/State *
              </Typography>
            </Form.Label>
            <Autocomplete
              options={provinces}
              getOptionLabel={(option) => option}
              autoComplete
              value={formInfo.province}
              blurOnSelect={true}
              freeSolo
              style={{ backgroundColor: 'white' }}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
              onChange={(e, val) => {
                handleForm('province', val);
              }}
              noOptionsText="Not from Canada? Just write which state you're from."
            />
          </Form.Group>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>
                <Typography variant="h5" className={classes.label}>
                  City *
                </Typography>
              </Form.Label>
              <Form.Control
                value={formInfo.city}
                onChange={(e) => {
                  handleForm('city', e.target.value);
                }}
                placeholder="Ex. London, Toronto, Calgary, Vancouver"
              />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>
                <Typography variant="h5" className={classes.label}>
                  Postal/Zip Code *
                </Typography>
              </Form.Label>
              <Form.Control
                value={formInfo.postalCode}
                onChange={(e) => {
                  handleForm('postalCode', e.target.value);
                }}
              />
            </Form.Group>
          </Form.Row>
        </Group>

        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              Do you want to receive swag from Hack Western? **Only if address
              is Canadian**
            </Typography>
          </Label>
          <Row>
            <Col md={6} lg={6} xl={6}>
              {formInfo.swag ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShowShirtSize(true);
                    handleForm('swag', true);
                  }}
                  className={classes.buttonSelect}>
                  Yes
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.buttonOption}
                  onClick={() => {
                    setShowShirtSize(true);
                    handleForm('swag', true);
                  }}>
                  Yes
                </Button>
              )}
            </Col>
            <Col>
              {formInfo.swag !== null && !formInfo.swag ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShowShirtSize(false);
                    handleForm('swag', false);
                  }}
                  className={classes.buttonSelect}>
                  No
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.buttonOption}
                  onClick={() => {
                    setShowShirtSize(false);
                    handleForm('swag', false);
                  }}>
                  No
                </Button>
              )}
            </Col>
          </Row>
        </Group>

        {showShirtSize && (
          <Group>
            <Label>
              <Typography variant="h3" className={classes.label}>
                What is your t-shirt size?
              </Typography>
            </Label>
            <FormControl variant="outlined" style={{ width: '100%' }}>
              <Select
                value={formInfo.shirtSize}
                onChange={(e) => {
                  handleForm('shirtSize', e.target.value);
                }}>
                {shirtSizes.map((shirtSize) => (
                  <MenuItem value={shirtSize} key={shirtSize}>
                    {shirtSize}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Group>
        )}

        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              Have you attended Hack Western before? *
            </Typography>
          </Label>
          <Row>
            {/* variant="outline-dark" */}
            <Col md={6} lg={6} xl={6}>
              {formInfo.attendedHWBefore ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleForm('attendedHWBefore', true);
                  }}
                  className={classes.buttonSelect}>
                  Yes
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.buttonOption}
                  onClick={() => {
                    handleForm('attendedHWBefore', true);
                  }}>
                  Yes
                </Button>
              )}
            </Col>
            <Col>
              {formInfo.attendedHWBefore !== null &&
              !formInfo.attendedHWBefore ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleForm('attendedHWBefore', false);
                  }}
                  className={classes.buttonSelect}>
                  No
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.buttonOption}
                  onClick={() => {
                    handleForm('attendedHWBefore', false);
                  }}>
                  No
                </Button>
              )}
            </Col>
          </Row>
        </Group>
        <Group>
          <Label>
            <Typography variant="h3" className={classes.label}>
              How many hackathons have you attended? *
            </Typography>
          </Label>
          <Row>
            {/* this should prob be in a function */}
            <Col md={6} lg={3} xl={3}>
              {formInfo.hackathonsAttendedBefore === '0' ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleForm('hackathonsAttendedBefore', '0');
                  }}
                  className={classes.buttonSelect}>
                  0
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.buttonOption}
                  onClick={() => {
                    handleForm('hackathonsAttendedBefore', '0');
                  }}>
                  0
                </Button>
              )}
            </Col>
            <Col md={6} lg={3} xl={3}>
              {formInfo.hackathonsAttendedBefore === '1-3' ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleForm('hackathonsAttendedBefore', '1-3');
                  }}
                  className={classes.buttonSelect}>
                  1-3
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.buttonOption}
                  onClick={() => {
                    handleForm('hackathonsAttendedBefore', '1-3');
                  }}>
                  1-3
                </Button>
              )}
            </Col>
            <Col md={6} lg={3} xl={3}>
              {formInfo.hackathonsAttendedBefore === '4-6' ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleForm('hackathonsAttendedBefore', '4-6');
                  }}
                  className={classes.buttonSelect}>
                  4-6
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.buttonOption}
                  onClick={() => {
                    handleForm('hackathonsAttendedBefore', '4-6');
                  }}>
                  4-6
                </Button>
              )}
            </Col>
            <Col md={6} lg={3} xl={3}>
              {formInfo.hackathonsAttendedBefore === '7+' ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleForm('hackathonsAttendedBefore', '7+');
                  }}
                  className={classes.buttonSelect}>
                  7+
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.buttonOption}
                  onClick={() => {
                    handleForm('hackathonsAttendedBefore', '7+');
                  }}>
                  7+
                </Button>
              )}
            </Col>
          </Row>
        </Group>
      </Form>
    </div>
  );
};

export default AboutYou;
